"use client"

import { useState } from "react"




import toast from 'react-hot-toast'
import ContactInfo from "./ContactFormInfo"
import TopContent from "./TopHeading"
import ContactForm from "./ContactForm"

export default function ContactPage() {
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        subject: "",
        message: "",
        newsletter: false,
    })

    async function handleSubmit(e) {
        e.preventDefault()
        const loadingToast = toast.loading('Submitting your request...')

        try {
            const res = await fetch('/api/contactus', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData),
            })

            toast.dismiss(loadingToast)

            if (res.ok) {
                toast.success('Request submitted successfully! We will contact you shortly.')
                setFormData({
                    firstName: '',
                    lastName: '',
                    email: '',
                    subject: '',
                    message: '',
                    newsletter: false,
                })
            } else {
                toast.error('Failed to send your request. Please try again later.')
            }
        } catch (error) {
            toast.dismiss(loadingToast)
            console.error(error)
            toast.error('Something went wrong. Please try again.')
        }
    }

    return (
        <div className="min-h-screen relative overflow-hidden">
            {/* Background Image */}
            <div
                className="absolute h-[500px] inset-0 bg-cover bg-center bg-no-repeat"
                style={{
                    backgroundImage: "url('/images/Background.avif')",
                }}
            >
            </div>

            {/* Content */}
            <div className="relative lg:hidden z-10 min-h-screen flex items-center justify-center pt-[142px] ">
                <div className="w-full max-w-7xl mx-auto">
                    <div className="grid  gap-8 lg:gap-16 items-center  sm:px-[64px]">

                        {/* Top Content Content */}
                        <TopContent />
                        <ContactForm formData={formData} setFormData={setFormData} handleSubmit={handleSubmit} />
                        <ContactInfo />
                        {/* Contact Information */}
                    </div>
                </div>
            </div>


            {/* Content */}

            <div className="relative hidden lg:block z-10 min-h-screen pt-[230px]">
                <div className="w-full px-[90px]  mx-auto">
                    <div className="flex items-start justify-evenly lg:gap-16 ">

                        {/* Top Content Content */}

                        <ContactForm formData={formData} setFormData={setFormData} handleSubmit={handleSubmit} />

                        <div className=" flex flex-col items-start justify-center gap-[20px] lg:gap-[30px]">
                            <TopContent />
                            <ContactInfo />
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

